import { Module } from 'vuex'

import { EditorPageStateModuleName } from '../modules'

import { GetJudgeDetailUseCase } from '@/application/judge/getJudgeDetailUseCase'
import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'

interface JudgeDetailState {
  judgeDetail: JudgeDetail | null
  testJudgeDetail: JudgeDetail | null
  isLoading: boolean
  error: string | null
}

export const judgeDetailModule = (judgeRepository: JudgeRepository): Module<JudgeDetailState, any> => {
  const getJudgeDetailUseCase = new GetJudgeDetailUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      judgeDetail: null,
      testJudgeDetail: null,
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeDetail(state, judgeDetail: JudgeDetail | null) {
        state.judgeDetail = judgeDetail
      },
      setTestJudgeDetail(state, judgeDetail: JudgeDetail | null) {
        state.testJudgeDetail = judgeDetail
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getJudgeDetail({ commit }, { judgeId, isTest }: { judgeId: string; isTest?: boolean }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const res = await getJudgeDetailUseCase.getJudgeDetail(judgeId)
          if (!isTest) {
            commit('setJudgeDetail', res)
          } else {
            commit('setTestJudgeDetail', res)
          }

          // 画面表示用のエラーメッセージの保存
          if (res.runtimeError) {
            commit(`${EditorPageStateModuleName}/setErrorMessage`, { errorMessage: res.runtimeError }, { root: true })
            commit(`${EditorPageStateModuleName}/setIsErrorShow`, { isErrorShow: true }, { root: true })
          } else if (res.compileError) {
            commit(`${EditorPageStateModuleName}/setErrorMessage`, { errorMessage: res.compileError }, { root: true })
            commit(`${EditorPageStateModuleName}/setIsErrorShow`, { isErrorShow: true }, { root: true })
          } else {
            commit(`${EditorPageStateModuleName}/setErrorMessage`, { errorMessage: null }, { root: true })
          }
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      judgeDetail: state => state.judgeDetail,
      testJudgeDetail: state => state.testJudgeDetail
    }
  }
}
